import { Injectable } from '@angular/core';

import { ApiService } from './api.service';

@Injectable()
export class ProfileService {
  private readonly vUrl = '/v3';
  private readonly resourceUrl = '/configurations';

  constructor(private apiService: ApiService) {}

  create(profile) {
    return this.apiService.post(`${this.vUrl}${this.resourceUrl}`, profile);
  }

  getOneZia(id) {
    return this.apiService.get(`${this.vUrl}${this.resourceUrl}/zia/${id}`);
  }

  getOneZpa(id) {
    return this.apiService.get(`${this.vUrl}${this.resourceUrl}/zpa/${id}`);
  }

  getAllZia() {
    return this.apiService.get(`${this.vUrl}${this.resourceUrl}/zia`);
  }

  getAllZpa() {
    return this.apiService.get(`${this.vUrl}${this.resourceUrl}/zpa`);
  }

  update(profile) {
    return this.apiService.put(
      `${this.vUrl}${this.resourceUrl}/${profile.id}`,
      profile
    );
  }

  delete(profile) {
    return this.apiService.delete(
      `${this.vUrl}${this.resourceUrl}/${profile.id}`
    );
  }
}
